export default __webpack_public_path__ + "static/media/preview-insta.81a48ef7.jpeg";